module.exports = __webpack_public_path__ + "img/left_ring.f6839e79.png";